export const MenuItems = [
  {
    title: "Home",
    url: "/",
    cName: "nav-links",
    icon: "fa-solid fa-house-user"
  },
  {
    title: "Sobre Nós",
    url: "/about",
    cName: "nav-links",
    icon: "fa-solid fa-circle-info"
  },
  {
    title: "Serviços",
    url: "/servicos",
    cName: "nav-links",
    icon: "fa-solid fa-cogs"
  },
  {
    title: "Portfólio",
    url: "/portfolio",
    cName: "nav-links",
    icon: "fa-solid fa-briefcase"
  },
  {
    title: "Contactos",
    url: "/contact",
    cName: "nav-links",
    icon: "fa-solid fa-address-book"
  }
];
